import { Card } from 'antd';
import { ConsignmentOrderBillingForm } from '../../components/ConsignmentOrderBilling/ConsignmentOrderBillingForm';
import { BackButton } from '../../uiComponents/BackButton';
import { useParams } from 'react-router-dom';
import { UrlPaths } from '../../../constants';
import { consignOrderBillingConst } from '../../../constants/ConsignOrderBilling.const';

export const ConsignOrderBillings = () => {
  const { id, numberOrder, consignmentOrderBillingId } = useParams();

  return (
    <Card
      title={
        <BackButton
          path={UrlPaths.CONSIGNMENT_ORDER_BILLING(id, numberOrder)}
          label={
            consignmentOrderBillingId
              ? consignOrderBillingConst.edit
              : consignOrderBillingConst.create
          }
        />
      }
      bordered={true}
      className="gx-card"
    >
      <ConsignmentOrderBillingForm
        consignmentOrderId={id}
        numberOrder={numberOrder}
        consignmentOrderBillingId={consignmentOrderBillingId}
      />
    </Card>
  );
};
